import { postCore as post } from "../utils/httpInterceptor";

class LoginService {
  /**
   * Login local (idax-platform):
   * POST /api/auth/login { username, password } -> { accessToken, refreshToken, roles }
   */
  static async login(username, password) {
    return await post("/api/auth/login", { username, password });
  }

  /**
   * Refresh access token:
   * POST /api/auth/refresh { refreshToken } -> { accessToken, refreshToken, roles }
   */
  static async refresh(refreshToken) {
    return await post("/api/auth/refresh", { refreshToken });
  }

  /**
   * Phase 2 of login when the response to login() was { status: "MFA_REQUIRED", challengeToken }.
   * `code` accepts either a 6-digit TOTP code (with or without a space) or a recovery code
   * ("XXXX-XXXX") - the backend tells them apart by shape.
   * POST /api/auth/mfa/verify { challengeToken, code } -> { accessToken, refreshToken, roles }
   */
  static async verifyMfa(challengeToken, code) {
    return await post("/api/auth/mfa/verify", { challengeToken, code });
  }

  /**
   * Phase 2 of login when the response to login() was { status: "MFA_SETUP_REQUIRED", setupToken }
   * (the user's tenant requires MFA and they have none configured yet). No session exists yet -
   * identity comes from the setupToken.
   * POST /api/auth/mfa/setup-required/start { setupToken } -> { secret, otpauthUri, issuer, digits, period }
   */
  static async startForcedMfaSetup(setupToken) {
    return await post("/api/auth/mfa/setup-required/start", { setupToken });
  }

  /**
   * POST /api/auth/mfa/setup-required/activate { setupToken, code } ->
   *   { recoveryCodes, generatedAt, accessToken, refreshToken, roles }
   */
  static async activateForcedMfaSetup(setupToken, code) {
    return await post("/api/auth/mfa/setup-required/activate", { setupToken, code });
  }

  /**
   * Logout - Limpia tokens de ambos storages
   */
  static logout() {
    // Limpiar localStorage
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("displayName");
    localStorage.removeItem("selectedTenant");
    localStorage.removeItem("selectedTenantId");
    localStorage.removeItem("selectedTenantCode");
    localStorage.removeItem("rememberMe");
    localStorage.removeItem("tenantId");
    
    // Limpiar sessionStorage
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("refreshToken");
    
    // Redireccionar a login
    window.location.href = "/";
  }
}

export default LoginService;
